import { onBeforeMount, onMounted } from 'vue';
import getOuterHeight from 'assets/js/functions/getOuterHeight';

const usePageScroll = (ref_float_element, base_class) => {
  const footer_selector = document.querySelector('.js-footer');

  const footer_height = footer_selector ? getOuterHeight('.js-footer') : 0;
  const android_window_offset = 140;
  let lastScrollTop = 0;

  const handleScroll = () => {
    if (!ref_float_element.value) return;

    const st = window.pageYOffset || document.documentElement.scrollTop;

    if (window.scrollY > 500) {
      ref_float_element.value.classList.remove(`${base_class}--last`);

      if (
        document.documentElement.scrollHeight - window.innerHeight - footer_height <=
        window.scrollY
      ) {
        ref_float_element.value.classList.add(`${base_class}--show`);

        if (
          document.documentElement.scrollHeight - window.innerHeight - android_window_offset <=
          window.scrollY
        ) {
          ref_float_element.value.classList.add(`${base_class}--last`);
        }
      } else if (st > lastScrollTop) {
        ref_float_element.value.classList.remove(`${base_class}--show`);
      } else {
        ref_float_element.value.classList.add(`${base_class}--show`);
      }
      lastScrollTop = st <= 0 ? 0 : st;
    } else {
      ref_float_element.value.classList.remove(`${base_class}--show`);
    }
  };

  onMounted(() => {
    window.addEventListener('scroll', handleScroll, false);
  });

  onBeforeMount(() => {
    window.removeEventListener('scroll', handleScroll);
  });
};

export default usePageScroll;
